module.exports = __webpack_public_path__ + "img/usdc.3f788bf4.png";